import { EnumComparison } from '@/models/EnumComparison';
import { FacturesParams } from '@/modules/SuiviFactures/services/SuiviFacturesService';

export default class RechercheFactureDTO {
    page?: number;
    sort?: string;
    joursAvantEcheance?: number;
    nbDerniersMois?: number;
    societe?: string;
    etablissement?: string;
    site?: string;
    fournisseur?: string;
    numeroFacture?: string;
    dateFrom?: string;
    dateTo?: string;
    comparison?: EnumComparison;
    montant?: number;
    chantierIds?: number[];

    constructor(params: FacturesParams) {
        this.page = params.page;
        this.sort = params.sort;
        this.joursAvantEcheance = params.joursAvantEcheance;
        this.nbDerniersMois = params.nbDerniersMois;
        this.societe = params.societe;
        this.etablissement = params.etablissement;
        this.site = params.site;
        this.fournisseur = params.fournisseur;
        this.numeroFacture = params.numeroFacture;
        this.dateFrom = params.dateFrom;
        this.dateTo = params.dateTo;
        switch (params.comparison) {
            case 'Supérieur à':
                this.comparison = EnumComparison.GREATER_THAN;
                break;
            case 'Inférieur à':
                this.comparison = EnumComparison.LESS_THAN;
                break;
            case 'Egal à':
                this.comparison = EnumComparison.EQUALS;
        }
        this.montant = params.montant;
        this.chantierIds = params.chantierIds;
    }
}
